<section class="tool-documentation">
    <div class="label-header">
        <h5>{{ 'admin.tools.details.documentsPage.fileManager.title' | translate }}</h5>
        <i *ngIf="shouldRenderModifiers()"
           (click)="refreshCache()" class="fa fa-refresh refresh-button"
           title="{{'admin.tools.details.documentsPage.labels.refreshButton' | translate}}"></i>
    </div>
    <app-display-label
        label="{{ 'admin.tools.details.documentsPage.labels.isDocumentationComplete' | translate }}"
        [value]="selectedTool?.documents?.isDocumentationComplete"
        [inlineLabel]="true"
        [valueClass]="selectedTool?.documents?.isDocumentationComplete ? 'good' : 'evil'">
    </app-display-label>
    <div class="divider"></div>
    <app-file-tree
        *ngIf="!isLoading; else loadingAnimation"
        [displayField]="'name'"
        [items]="selectedTool?.documents?.toolDocuments"
        [hasContextMenu]="shouldRenderModifiers()"
        (onLinkPath)="editPath($event)"
        (onDownloadFile)="downloadFile($event)"
        (onCardinalityChange)="openCardinalityChangeModal($event)">
    </app-file-tree>
</section>

<app-document-tree-modal #treeModal
                         (onUpdate)="createDocumentLocations($event)"
                         [displayField]="'name'"
                         [toolId]="selectedTool?.id"
                         [hasRootPath]="selectedTool?.documents?.hasRootPath">
</app-document-tree-modal>

<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>

<app-confirmation-modal #cardinalityConfirmation
                        confirmOnlyMode="true"
                        (confirmEvent)="updateDocumentCardinality()"
                        title="{{'admin.tools.details.documentsPage.cardinality-modal.title' | translate}}"
                        message="{{'admin.tools.details.documentsPage.cardinality-modal.question' | translate}}">
</app-confirmation-modal>
